import * as React from "react";
import { forwardRef } from "react";
const ShareSVG = (props, ref) => React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", ref: ref, ...props },
    React.createElement("path", { d: "M12.5 6a2.5 2.5 0 1 0-2.497-2.37l-4.9 2.45a2.5 2.5 0 1 0 0 3.838l4.9 2.452-.003.13a2.5 2.5 0 1 0 .898-1.92L5.997 8.13a3 3 0 0 0 0-.26l4.9-2.45c.435.362.993.58 1.603.58" }));
const ForwardRef = forwardRef(ShareSVG);
export default ForwardRef;
//# sourceMappingURL=Share.js.map